(function($) {
    var tl = gsap.timeline({repeat: -1, repeatDelay: 2});
    tl.from(".index-banner .logo-line-1", {width: "50vw", duration: 1});
    tl.from(".index-banner .logo-line-2", {scaleY: 0, duration: 1}, "-=0.5");
    tl.from(".index-banner .logo-line-5", {height: "40vh", duration: 1}, "-=0.65");
    tl.from(".index-banner .logo-line-3", {height: "55vh", duration: 1}, "-=0.65");
    tl.from(".index-banner .logo-line-4", {height: "70vh", duration: 1}, "-=0.65");
    tl.from(".index-banner .logo-line-6", {width: "50vw", duration: 0.7}, "-=1.5");
    tl.from(".index-banner .logo-line-7", {height: 0, duration: 0.5}, "-=1");
    tl.from(".index-banner .logo-line-8", {width: 0, duration: 0.5}, "-=0.5");
    tl.from(".index-banner .logo-line-9", {height: 0, duration: 0.5}, "-=0.15");
    tl.from(".index-banner .logo-line-10", {width: 0, x: 94, duration: 0.5}, "-=0.15");
    tl.from(".index-banner .logo-line-11", {height: 0, duration: 0.5}, "-=0.15");
    tl.from(".index-banner .logo-line-12", {width: 0, duration: 0.5}, "-=0.15");
    tl.from(".index-banner .logo-line-13", {height: 0, y: 69, duration: 0.5}, "-=0.15");
    tl.from(".index-banner .logo-line-14", {width: 0, x: 60, duration: 0.5}, "-=0.15");
    tl.from(".index-banner .logo-line-15", {height: 0, duration: 0.5}, "-=0.15");
    tl.from(".index-banner .leaf", {opacity: 0, y: 50, scaleX: 0, duration: 0.5}, "+=0.15");
    tl.from(".index-banner .txt", {opacity: 0, y: 50, duration: 0.5}, "-=0.15");
    tl.to(".index-banner .bg-leaf", {
        scale: 0,
        x: "random(-50, 50, 2)" + 'vw',
        y: "random(-50, 50, 2)" + 'vh',
        rotation: "random(0, 360, 2)",
        duration: 0.5,
    }, "-=0.1");
    tl.to(".index-banner .bg-leaf", {
        opacity: 1,
        scale: 1,
        duration: "random(0.2, 1)",
    });
    tl.to(".index-banner .bg-leaf", {
        opacity: 0,
        scale: 0,
        duration: "random(0.2, 1)",
    }, "+=0.1");
    tl.to(".index-banner .bg-leaf", {
        scale: 0,
        x: "random(-50, 50, 2)" + 'vw',
        y: "random(-50, 50, 2)" + 'vh',
        rotation: "random(0, 360, 2)",
        duration: 0.5,
    }, "-=0.1");
    tl.to(".index-banner .bg-leaf", {
        opacity: 1,
        scale: 1,
        duration: "random(0.2, 1)",
    });
    tl.to(".index-banner .bg-leaf", {
        opacity: 0,
        scale: 0,
        duration: "random(0.2, 1)",
    }, "+=0.1");
    tl.to(".index-banner .bg-leaf", {
        scale: 0,
        x: "random(-50, 50, 2)" + 'vw',
        y: "random(-50, 50, 2)" + 'vh',
        rotation: "random(0, 360, 2)",
        duration: 0.5,
    }, "-=0.1");
    tl.to(".index-banner .bg-leaf", {
        opacity: 1,
        scale: 1,
        duration: "random(0.2, 1)",
    });
    tl.to(".index-banner .bg-leaf", {
        opacity: 0,
        scale: 0,
        duration: "random(0.2, 1)",
    }, "+=0.1");

    $('.index-banner').on('click', '.bt-scroll', function(e) {
        var t = $(this).attr('href');
        setTimeout(() => {
            $('html,body').stop().animate({
                scrollTop: $(t).offset().top - $('.site-title').outerHeight() + 40
            }, 400);
        }, 300);
        return false;
    });

    $('.index-project-slider').slick({
        arrows: true,
        dots: false,
    });
    $('.project-pic-slider').slick({
        fade: true,
        arrows: false,
        dots: true,
        swipe: false,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: false,
    });
})($);